import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageContainer from "../components/PageContainer";
import PageTitle from "../components/PageTitle";
import CardContainer from "../components/CardContainer";
import ActivityCard from "../components/ActivityCard";
import Error from "../components/Error";

export const FavouritesPage = () => {

    const { t } = useTranslation();
    const token = localStorage.getItem('ticino-wild-token');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {favourites } = useSelector(state => state.user);

    // Mando favourites in backend per riceverne le attività corrispondenti
    const [favouritesData, setFavouritesData] = useState([]);
    const [isFavouritesLoading, setIsFavouritesLoading] = useState(false);
    const [favouritesError, setFavouritesError] = useState(null);
    useEffect(() => {
        if (favourites) {
            if (favourites.length > 0) {
                favouritesDataFetch();
            }
        }
    }, [favourites])

    const favouritesDataFetch = async () => {
        setIsFavouritesLoading(true);
        try {
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activities/get-user-activities-by-id-array`;
            const headers = {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            };
            const options = {
                method: 'POST',
                headers,
                body: JSON.stringify({ favouritesIdArray: favourites })
            };
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setFavouritesData(result.payload);
                setIsFavouritesLoading(false);
            } else {
                const error = await response.json();
                throw error;
            }
        } catch (error) {
            console.error(error.message || "Errore durante la richiesta Favourites.");
            setFavouritesError(error);
            setIsFavouritesLoading(false);
        }
    }

    return (
        <PageContainer desktopItems="center">
            <PageTitle backLink="/" title={t('FavouritesPage.title')} />

            {/* CARD CONTAINER */}
            <div className="flex flex-col py-4">
                {
                    favouritesData && !isFavouritesLoading && !favouritesError &&
                    <CardContainer>
                        {
                            favouritesData.length > 0 && favouritesData.map((element, index) => {
                                return <ActivityCard key={index} activityData={element} />
                            })
                        }
                    </CardContainer>
                }
                {
                    favouritesError && !isFavouritesLoading &&
                    <Error />
                }

            </div>
        </PageContainer>
    )
}